import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, FloatingLabel, Form, FormControl, Modal, Row, Spinner } from "react-bootstrap";
import defaultAvatar from '../../user.png';
import PrivateApi from "../../services/PrivateApiService";
import ProfileForm from "../../components/shared/ProfileForm";
import SplashPage from '../../pages/SplashPage';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { FaFilePdf } from "react-icons/fa";

const ProfilePage = () => {

    const [user, setUser] = useState();
    const API = new PrivateApi();

    const [dataLoading, setDataLoading] = useState(false);

    const [pass1, setPass1] = useState("");
    const [pass2, setPass2] = useState("");

    const [passwordModal, setPasswordModal] = useState(false);
    const [passwordLoading, setPasswordLoading] = useState(false);
    const [passwordChanged, setPasswordChanged] = useState(false);
    const [passError, setPassErr] = useState("");

    const [imageModal, setImageModal] = useState(false);
    const [profileImage, setProfileImage] = useState();

    const [updated, setUpdated] = useState(false);
    const [profileImageLoading, setProfileImageLoading] = useState(false);
    const [profileImageChanged, setProfileImageChanged] = useState(false);

    const [dataChange, setDataChange] = useState(false);

    const [personalId, setPersonalId] = useState(null);
    const [personalIdLoading, setPersonalIdLoading] = useState(false);
    const [personalIdModal, setPersonalIdModal] = useState(false);
    const [personalIdChanged, setPersonalIdChanged] = useState(false);



    useEffect(() => {
        setDataLoading(true);
        API.get_UserLogged()
            .then(res => {
                let data = res.data;
                setUser(data);
                setDataLoading(false);
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getBase64 = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setProfileImage(reader.result);
        }
    }

    const getBase644 = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setPersonalId(reader.result);
        }
    }


    const changePassHandler = () => {
        setPassErr("");
        setPasswordLoading(true);
        setPasswordChanged(false);
        if (pass1 !== "" && pass1 === pass2 && pass1.length >= 6) {
            API.changePassword_Partner({ password: pass1 })
                .then(() => {
                    setPasswordChanged(true);
                    setPasswordLoading(false);
                })
                .catch(e => {
                    setPasswordLoading(false);
                    setPassErr("Serverfehler! Versuchen Sie es später erneut")
                });
        } else {
            setPasswordLoading(false);
            if (pass1 === "" || pass2 === "") {
                setPassErr("Das Passwortfeld darf nicht leer sein");
            }
            if (pass1 !== pass2) {
                setPassErr("Passwörter müssen gleich sein");
            }
            if (pass1.length < 6) {
                setPassErr("Passwort muss mindestens 6 Zeichen lang sein")
            }
        }
    }

    const uploadImageHandler = () => {
        setProfileImageLoading(true);
        if (profileImage !== undefined && profileImage !== '') {
            API.post_PartnerImage({ image: String(profileImage).split(',')[1] })
                .then(() => {
                    setProfileImageChanged(true);
                    setProfileImageLoading(false);
                    setImageModal(false);
                    user.image_1920 = String(profileImage).split(',')[1];
                })
        }
    }


    const uploadPersonalId = () => {
        setPersonalIdLoading(true);
        if (personalId !== undefined && personalId !== '') {
            API.post_PartnerPersonalId({ image: String(personalId).split(',')[1] })
                .then(() => {
                    setPersonalIdChanged(true);
                    setPersonalIdLoading(false);
                    setPersonalIdModal(false);
                    user.x_file_ausweiskopie = String(personalId).split(',')[1];
                })
        }
    }


    const downloadFile = (b64, fileName) => {
        const linkSource = `data:application/pdf;base64,${b64}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    if (dataLoading) return <SplashPage />

    return (
        <>
            {!updated ?
                    <Container className="text-start">
                        <h2>Profil</h2>
                        <p className="text-muted">Hier können Sie Ihre Daten ändern</p>
                        <Row className="mt-4">
                            <Col xs="12" xl="8">
                                <Card style={{borderRadius: 15, borderBottom: "3px solid #a2c13f"}} className="shadow-lg">
                                    <Card.Body>
                                        <Row>
                                            <Col xs="4" md="3" xl="3" className="text-center border-right">
                                                <img src={user?.image_1920 && user.image_1920 !== "False" ? 'data:image/jpeg;base64,' + user.image_1920 : defaultAvatar} alt="avatar" className="img-fluid img-darken" width={200} />
                                            </Col>
                                            <Col xs="12" xl="9">
                                                <div style={{marginLeft: 10}}>
                                                    <h4>{user?.name}</h4>
                                                    <span className="text-muted">Kundennummer: </span> &nbsp; {user?.x_poolmember_seqnr} <br />
                                                    <span className="text-muted" hidden={user?.x_pool_accession_date === "False"}>Poolbeitritt: </span> &nbsp;  {new Date(user?.x_pool_accession_date).toLocaleDateString('DE-de')} <br />
                                                    <span className="text-muted">Adresse: </span> &nbsp; {user?.street} <br />
                                                    <span className="text-muted">PLZ: </span> &nbsp; {user?.zip} <br />
                                                    <span className="text-muted">Ort: </span> &nbsp; {user?.city} <br />
                                                </div>
                                                <Row className="text-center mt-3">
                                                    <Col xs="6" className="border-right">
                                                        {user?.x_file_vollmacht !== undefined && user?.x_file_vollmacht !== ""?
                                                            <a href="download/Vollmacht" onClick={e => {e.preventDefault(); downloadFile(user?.x_file_vollmacht, user?.x_file_vollmacht_name)}} className="link-energo"><FaFilePdf size={20} /> Download Vollmacht</a>
                                                            :
                                                            <span className="text-muted">Vollmacht nicht vorhanden</span>
                                                        }
                                                    </Col>
                                                    <Col xs="6">
                                                        {user?.x_file_ausweiskopie !== undefined && user?.x_file_ausweiskopie !== "" && user?.x_file_ausweiskopie !== "False"?
                                                            <a href="download/Ausweiskopie" onClick={e => {e.preventDefault(); downloadFile(user?.x_file_ausweiskopie, user.x_file_ausweiskopie_name)}} className="link-energo"><FaFilePdf size={20} /> Download Ausweiskopie</a>
                                                            :
                                                            <span className="text-muted">Ausweiskopie nicht vorhanden</span>
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs="12" xl="4">
                                <Card style={{borderRadius: 15, borderBottom: "3px solid #a2c13f" }} className="shadow-lg">
                                    <Card.Body>
                                        <h4>Aktionen</h4>
                                        <a href="/ändern" onClick={e => {e.preventDefault(); setDataChange(!dataChange)}} className="link-energo">{dataChange? "Stammdaten ausblenden": "Stammdaten ändern"}</a> <br />
                                        {profileImageChanged ?
                                            <><span>Profilbild ist geändert!</span> <br /></>
                                        :
                                            <><a href="/ändern" onClick={e => { e.preventDefault(); setImageModal(true) }} className="link-energo">Profilbild ändern</a> <br /></>
                                        }
                                        <a href="passwort/ändern" onClick={e => {e.preventDefault(); setPasswordModal(true)}} className="link-energo">Passwort ändern</a> <br />
                                        <a href="/ausweiskopie" onClick={e => {e.preventDefault(); setPersonalIdModal(true)}} className="link-energo">Ausweiskopie ändern</a>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {
                            dataChange? 
                            user !== undefined ? <ProfileForm user={user} updated={setUpdated} personalIdModal={setPersonalIdModal} personalIdChanged={personalIdChanged} /> : null
                            :null
                        }

                        <Modal show={passwordModal} onHide={() => setPasswordModal(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Passwort ändern</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    {!passwordChanged ?
                                        passwordLoading ?
                                            <Col xs="12" className="text-center">
                                                <p>Passwort wird zum Server übermittelt...</p>
                                                <Spinner animation="grow" className="text-energo" /> &nbsp;
                                                <Spinner animation="grow" className="text-energo" /> &nbsp;
                                                <Spinner animation="grow" className="text-energo" />
                                            </Col>
                                            :
                                            <Col xs="12">
                                                <Row>
                                                    <Col>
                                                        <Form.Group>
                                                            <FloatingLabel label="Passwort">
                                                                <FormControl type="password" value={pass1} onChange={e => setPass1(e.target.value)} />
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-1">
                                                    <Col>
                                                        <Form.Group>
                                                            <FloatingLabel label="Passwort wiederholen">
                                                                <Form.Control type="password" value={pass2} onChange={e => setPass2(e.target.value)} />
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="text-center">
                                                        <small className="text-danger">{passError}</small>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        :
                                        <Col xs="12" className="text-center">
                                            <AiOutlineCheckCircle size={50} className="text-energo" />
                                            <p>Ihr Passwort wurde geändert</p>
                                        </Col>
                                    }
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                {passwordChanged ?
                                    <Button onClick={() => setPasswordModal(false)} className="btn-energo">Ok</Button>
                                    :
                                    <>
                                        <Button onClick={() => setPasswordModal(false)} variant="warning">Abbrechen</Button>
                                        <Button onClick={() => changePassHandler()} className="btn-energo">Speichern</Button>
                                    </>
                                }
                            </Modal.Footer>
                        </Modal>
                        <Modal show={imageModal} onHide={() => setImageModal(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Profilbild ändern</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {profileImage !== undefined ? <img src={profileImage} alt="" className="img-fluid" /> : null}
                                <Row className="mt-3">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Wählen Sie Ihr neues Profilbild</Form.Label>
                                            <Form.Control type="file" accept="image/*" onChange={e => getBase64(e.target.files[0])} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                {profileImageLoading ?
                                    <Spinner animation="border" className="text-energo" />
                                    :
                                    <Button hidden={profileImage === undefined || profileImage === ''} onClick={() => uploadImageHandler()} className="btn-energo">Speichern</Button>
                                }
                            </Modal.Footer>
                        </Modal>
                        <Modal show={personalIdModal} onHide={() => setPersonalIdModal(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Ausweiskopie hinzufügen</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {personalId !== undefined ? <img src={personalId} alt="" className="img-fluid" /> : null}
                                <span className="text-muted">
                                    Bitte laden Sie hier eine gültige Ausweiskopie hoch (Reisepass, Führerschein, Personalausweis).
                                    Achten Sie darauf, das Bild und Text auf Ihrem Dokument gut lesbar sind.
                                </span>
                                <Row className="mt-4">
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Wählen Sie Ihre Dokument (Bild oder Pdf)</Form.Label>
                                            <Form.Control type="file" accept="image/*, application/pdf" onChange={e => getBase644(e.target.files[0])} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                {personalIdLoading ?
                                    <Spinner animation="border" className="text-energo" />
                                    :
                                    <Button hidden={personalId === undefined || personalId === ''} onClick={() => uploadPersonalId()} className="btn-energo">Speichern</Button>
                                }
                            </Modal.Footer>
                        </Modal>
                    </Container>
                :
                <Container>
                    <Row className="justify-content-center">
                        <Col xl="8">
                            <Card>
                                <Card.Body>
                                    <AiOutlineCheckCircle className="text-energo" size={70} />
                                    <br /><br />
                                    <figure className="text-center">
                                        <blockquote className="blockquote">
                                            <p>
                                                Die von Ihnen geänderten Daten wurden an <b className="text-energo">ENERGO</b> übermittelt.
                                                Die Anpassung der Daten erfolgt in Kürze. Bei Unklarheiten kommen wir auf Sie zurück.
                                            </p>
                                        </blockquote>
                                        <figcaption className="blockquote-footer text-end">
                                            <span className="text-energo">Ihr ENERGO Team</span>
                                        </figcaption>
                                    </figure>
                                    <br />
                                    <a href={user?.company_type === 'person' ? '/dashboard' : '/hw/dashboard'} className="btn btn-energo">Zurück zur Startseite</a>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            }
        </>
    )
}

export default ProfilePage;